module.exports = __webpack_public_path__ + "static/media/kplus-logo.5c9e53ad.png";